var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarassment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #e63030;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Harassment"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 22.87,
    cy: 15.45,
    r: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.79,17.91c.11-.99.62-1.34,1.23-1.34.66,0,1.14.68,1.14,1.34v4.62h.83v-12.3c0-.65.53-1.18,1.19-1.18s1.19.53,1.19,1.18v8.34h.87v-9.76c0-.65.53-1.19,1.19-1.19s1.19.53,1.19,1.19v9.76h.84v-8.34c0-.65.53-1.18,1.19-1.18s1.19.53,1.19,1.18v9.34h.82v-5.24c0-.65.53-1.19,1.19-1.19s1.18.53,1.18,1.54v9.51c0,3.09-3.38,6.95-7.52,6.95s-7.69-3.86-7.69-7.66h0v-5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.61,29.07c-1.33-1.65-2.16-3.71-2.16-5.89v-.65c-.54-.25-1.48-.7-2.58-.91-1.3-.25-2.05-.19-2.05-.19h-10.46c-1.08,0-2.01.18-2.81.48.13-.41.2-.84.2-1.29,0-2.32-1.89-4.21-4.2-4.21s-4.21,1.89-4.21,4.21c0,1.6.89,2.99,2.21,3.7h-2.25c-2.98,0-5.31,2.44-5.31,5.56v12.49s9.81,0,9.81,0h0s4.29.01,4.29.01v-14.38s1.59,0,1.59,0v14.38h12.58v-15.34s5.33,2.03,5.33,2.03ZM10.8,27.69v13.38s-4.56,0-4.56,0v-11.54h-2.25v11.53s-1.68,0-1.68,0v-11.2c-.01-2.43,1.72-4.27,4.01-4.27h4.8c-.21.67-.31,1.38-.31,2.08ZM10.55,23.53c-1.61,0-2.91-1.31-2.91-2.91s1.31-2.91,2.91-2.91,2.91,1.31,2.91,2.91c0,1.61-1.31,2.91-2.91,2.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50,
    height: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarassment);
export default __webpack_public_path__ + "static/media/harassment.2044e6967bf39506d6c33c524671c4ba.svg";
export { ForwardRef as ReactComponent };